var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overview-container"},[_c('h1',[_vm._v("Experience")]),_c('actor-experience-form',{attrs:{"experience":_vm.user.experience,"loading":_vm.updateLoading},on:{"save":_vm.updateUser}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }